// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.service.proxy.ProxyType
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let ProxyType = /*#__PURE__*/function (ProxyType) {
  ProxyType[ProxyType["ENTITY"] = 0] = "ENTITY";
  ProxyType[ProxyType["EXPRESSIT"] = 1] = "EXPRESSIT";
  ProxyType[ProxyType["QUERYITADMIN"] = 2] = "QUERYITADMIN";
  ProxyType[ProxyType["CONTROLCENTER"] = 3] = "CONTROLCENTER";
  ProxyType[ProxyType["DATASETCATALOG"] = 4] = "DATASETCATALOG";
  ProxyType[ProxyType["AICENTRAL"] = 5] = "AICENTRAL";
  ProxyType[ProxyType["ABSDK"] = 6] = "ABSDK";
  ProxyType[ProxyType["AUTH_GATEWAY"] = 7] = "AUTH_GATEWAY";
  ProxyType[ProxyType["EXTERNAL"] = 8] = "EXTERNAL";
  return ProxyType;
}({});
(function (_ProxyType) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? ProxyType[enumVal] != null ? enumVal : undefined : ProxyType[enumVal];
  }
  _ProxyType.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _ProxyType.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _ProxyType.indexOf = indexOf;
})(ProxyType || (ProxyType = {}));
//# sourceMappingURL=ProxyType.js.map
